import { Divider, Grid } from "@mui/material"

type Direction = "vertical" | "horizontal"

type ResizeControlProps = {
  onResize: (event: MouseEvent) => void
  direction: Direction
}

const ResizeControl = (props: ResizeControlProps) => {
  const handleMouseDown = () => {
    document.addEventListener("mouseup", handleMouseUp, true)
    document.addEventListener("mousemove", props.onResize, true)
  }

  const handleMouseUp = () => {
    document.removeEventListener("mouseup", handleMouseUp, true)
    document.removeEventListener("mousemove", props.onResize, true)
  }

  const minorDividerSize = getMinorDividerSize(props.direction)
  const majorDividerSize = getMajorDividerSize(props.direction)

  const resizeHorizontally = props.direction === "horizontal"

  return (
    <Grid
      container
      direction={resizeHorizontally ? "column" : "row"}
      spacing="2px"
      wrap="nowrap"
      alignItems="center"
      justifyContent="center"
      onMouseDown={handleMouseDown}
      sx={{
        "& > *": { userSelect: "none" },
        ...(!resizeHorizontally && { height: "100%" }),
        cursor: resizeHorizontally ? "ns-resize" : "ew-resize",
        border: "0px solid #ddd",
        backgroundColor: "#fff",
        p: "1px",
      }}
    >
      {/*<Grid item xs="auto">*/}
      {/*  <Divider sx={{ ...minorDividerSize, backgroundColor: "#928a8a" }} />*/}
      {/*</Grid>*/}
      <Grid item xs="auto" sx={{ ml: "2px", mt: "2px", mr: "10px" }}>
        <Divider
          sx={{
            ...majorDividerSize,
            backgroundColor: "#fff",
            borderRight: "5px dotted #ccc",
            borderTop: "5px dotted #ccc",
            borderBottom: "0px dotted #ccc",
          }}
        />
      </Grid>
      {/*<Grid item xs="auto">*/}
      {/*  <Divider sx={{ ...minorDividerSize, backgroundColor: "#928a8a" }} />*/}
      {/*</Grid>*/}
    </Grid>
  )
}

export default ResizeControl

const getMinorDividerSize = (direction: Direction) => {
  if (direction === "horizontal") return { width: "15px", height: "1px" }

  return { width: "1px", height: "15px" }
}

const getMajorDividerSize = (direction: Direction) => {
  if (direction === "horizontal") return { width: "30px", height: "2px" }

  return { width: "0px", height: "20px" }
}
